<template>
  <div id="app">
    <keep-alive :include="cachedViews">
      <router-view />
    </keep-alive>
  </div>
</template>

<script>
export default {
  name: 'App',
  computed: {
    cachedViews() {
      return ['ArticleList', 'PFA', 'course']
    }
  }
}
</script>

<style>
/* 重置全局样式 */
* {
  padding: 0;
  margin: 0;
}

html,
body {
  height: 100%;
}

#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif, Source Han Sans CN, Source Han Sans CN, Hiragino Sans GB, Microsoft YaHei, WenQuanYi Micro Hei, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  position: relative;
  height: 100%;
}

/* 禁用用户选择文本 */
*:not(input, textarea) {
  -webkit-touch-callout: none; /* 系统默认菜单被禁用 */
  -webkit-user-select: none; /* webkit浏览器 */
  -khtml-user-select: none; /* 早期浏览器 */
  -moz-user-select: none; /* 火狐 */
  -ms-user-select: none; /* IE10 */
  user-select: none;
}

/* 提升 Toast 组件的层级 */
.van-toast {
  z-index: 9999999 !important;
}

/* 设置编辑器最小高度 */
.ql-editor {
  min-height: 200px;
}

/* 文章主内容和直播盒子中的所有元素最大宽度为父容器宽度，并去除外边距，居中文本 */
.article-main * :not(.video-js *),
.live-box * :not(.video-js *){
  max-width: 100%;
  margin: 0;
  text-align: justify;
  list-style: disc;
  font-family: mp-quote, "Source Han Sans CN, Source Han Sans CN", system-ui, -apple-system, BlinkMacSystemFont, "Helvetica Neue", "Hiragino Sans GB", "Microsoft YaHei UI", "Microsoft YaHei", Arial, sans-serif !important;
}
</style>



// WEBPACK FOOTER //
// src/App.vue